import { createFileRoute, redirect } from "@tanstack/react-router";

import { CreatePage } from "~/pages/create/create.page";

export const Route = createFileRoute("/create")({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: "/login", replace: true });
    }
  },
  component: CreatePage,
});
